module.exports = __webpack_public_path__ + "img/banner-fugong.c4a17bb2.png";